<template>
  <div class="cardGuide">
    <div class="cardTop"> 
      <!-- <div>阅读量:{{item.hits}}</div> -->
      <div v-for="item in datalist" :key="item.id">
        <div class="cardBody">
          <img :src="item.icon" class="cardImage" />
          <div style="float:left">
            <div style="float:left;margin-top:6.481vh">
              <div class="cardName">{{ item.name }}</div>
              <div style="display:flex;flex-direction:row;">
                <div v-for="items in Number(item.level)" :key="items">
                  <img class="cardxx" src="@/assets/image/xxshow.png" />
                </div>
                <div v-for="item in 5 - Number(item.level)" :key="item.id">
                  <img class="cardxx" src="@/assets/image/xx.png" />
                </div>
              </div>
            </div>
            <br />
            <div class="cardDesc">
              {{ item.brief }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cardListFooter">
      <NewPagunation
        :nowCurrent="current"
        :total="total"
        :pageSize="pageSize"
        @getPage="getPage"
      ></NewPagunation>
    </div>
  </div>
</template>

<script>
import  {addHits}  from "@/util/publicHits";
import { getMenuOpenList } from "@/api/publicApi";

import TopButtom from "@/components/common/TopButtom.vue";
import NewPagunation from "@/components/common/NewPagunation.vue";
// import { getGuideList } from "@/api/common";
export default {
  name: "CardList",
  components: { NewPagunation, TopButtom },
  props: ["deviceId"],
  data() {
    return {
      current: 1,
      pageSize: 4,
      total: 0,
      datalist:[]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        this.getInfoListFunction();
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {},
  computed: {},
  methods: {
    //导游列表
    async getInfoListFunction() { 
      
      let level = this.$store.state.tabPage; 
      var typeName = ''
      
      if(level == 1){
        typeName = 'middleGuide'
      }
      if(level == 2){ 
        typeName = 'starGuide'
      }
      if(level == 3){
        typeName = 'characteristicGuide'
      } 
      const { code, data } = await getMenuOpenList(0,typeName, this.current, this.pageSize);
      if (code == 200) { 
        if(data.records.length > 0){
        this.datalist = data.records;
        let BASE_URL = this.Global;
        this.datalist.forEach((element,index) => {
          element.icon != null ? (element.icon = `${BASE_URL}${element.icon}`) : "";
          element.brief != null ? (element.brief = element.brief.slice(0, 176) + ".....") : "";
          this.datalist[index].level ? '': (this.datalist[index].level =  0)
        });
        this.total = data.total;
        }else{
          console.log("数据有问题")
        }

      }
    },
    changeDataList(data) {},
    //详情
    seeInfo(info) {
      this.$store.commit("setInfo", info);
      this.$emit("seeInfo", info);
    },
    getPage(current) {
      this.current = current;
      this.getInfoListFunction();
    }
  }
};
</script>
<style scoped>
.cardListFooter {
  width: 100%;
  text-align: center;
  height: 5.5555vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.222vh;
}
.cardTop {
  display: flex;
  flex-flow: row wrap;
  margin-left: 2%;
  /* justify-content: center;
  align-items: center; */
  /* margin: 136px 6% 20px 5%; */
}
/* @media screen and (max-width: 1900px) {
  .cardTop {
    justify-content: center;
    align-items: center;
  }
} */
.cardBody {
  min-width: 33.28125vw;
  min-height: 23.2407vh;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.13);
  margin: 2.87vh 1.0416vw 0px 1.0416vw;
}
.cardBody .cardImage {
  max-width: 8.59375vw;
  max-height: 20vh;
  margin: 1.666vh 1.30208vw 1.574vh 1.09375vw;
  float: left;
}
.cardBody .cardName {
  font-size: 1.6667vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #333333;
  line-height: 1.759vh;
  float: left;
  margin-right: 0.5729vw;
}
.cardBody .cardxx {
  width: 1.2962vh;
  height: 1.2962vh;
  /* float: left; */
  margin-left: 0.2083vw;
}
.cardBody .cardDesc {
  font-size: 1.2962vh;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #888888;
  float: left;
  width: 20.677vw;
  height: 5.7407vh;
  margin-top: 3.055vh;
}

.cardGuide::-webkit-scrollbar {
  width: 8px;
  /*height: 4px;*/
}
/* 滑块 */
.cardGuide::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #ababab;
}
/* 滑槽 */
.cardGuide::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
}
.cardGuide {
  height: 660px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/guide/cardList.vue